<template>
  <div>
    <!-- 商品售后 -->
    <div class="detail" v-loading="loading">
      <!-- 顶部 -->
      <detailHeader />
      <div class="baseBreadcrumb">
        <!-- 售后 -->
        <baseBreadcrumb :page="$t('message.afterSale')" :menu="$t('message.money')"></baseBreadcrumb>
      </div>
      <!--  售后-售后详情 -->
      <div class="content">
        <div class="head" v-if="detail.after_sale_sn">
          <div class="item">
            <!-- 售后编号 -->
            <p>
              {{ $t("message.afterSalesOrderNumber") }}：{{ detail.after_sale_sn }}
            </p>
            <!-- 配送单号 -->
            <p>
              {{ $t("message.deliveryNoteNumber") }}： <router-link :to="'/porderDetail?porder_sn=' + detail.porder_sn"
                targe="_blank" class="a-link">
                {{ detail.porder_sn }}
              </router-link>
            </p>
          </div>
          <div class="item">
            <!-- 提出人 -->
            <p>
              {{ $t("message.peoplePutForward") }}：{{ detail.created_admin ? detail.created_admin.realname : "" }}
            </p>
            <!-- 业务 -->
            <p>
              {{ $t("message.business") }}：
              {{ detail.porder.y_admin ? detail.porder.y_admin.realname : '' }}
            </p>
          </div>
          <div class="item">
            <!-- 确认人 -->
            <p>
              {{ $t("message.affirmName") }}：{{ detail.confirm_admin ? detail.confirm_admin.realname : "" }}
            </p>
            <!-- 采购 -->
            <p>
              {{ $t("message.purchase") }}：{{ detail.porder.g_admin ? detail.porder.g_admin.realname : '' }}
            </p>
          </div>
          <div class="item">
            <!-- 售后状态 -->
            <p>{{ $t("message.afterSaleStatus") }}：{{ detail.status_name }}</p>
            <!-- 配货 -->
            <p>
              {{ $t("message.distribution") }}：{{ detail.porder.p_admin ? detail.porder.p_admin.realname : '' }}
            </p>
          </div>
          <div class="item">
            <!-- 售后类别 -->
            <p>{{ $t("message.afterSaleCategory") }}：{{ detail.type_name }}</p>
            <!-- 贴标 -->
            <p v-if="detail.porder.fba_admin">
              {{ $t("message.labeling") }}：{{ detail.porder.fba_admin ? detail.porder.fba_admin.realname : '' }}
            </p>
          </div>
          <!--联系客户  -->
          <el-button type="danger">{{
            $t("message.contactCustomer")
          }}</el-button>
        </div>
        <!-- 状态筛选 -->
        <div class="tabs">
          <el-tabs v-model="status" type="card" @tab-click="handleClick">
            <!-- 售后单详情 -->
            <el-tab-pane :label="$t('message.detailsOfAfterSalesOrder')" name="1"></el-tab-pane>
            <!-- 赔款 -->
            <el-tab-pane :label="item.reparation_sn" :name="item.reparation_sn"
              v-for="(item, index) in detail.reparations" :key="index">
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 列表 -->
        <div class="table" v-if="status == 1">
          <ol>
            <!--  选择-->
            <li class="flex05">
              {{ $t("message.choose") }}
            </li>
            <!--  番号-->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--  图片-->
            <li>{{ $t("message.pic") }}</li>
            <!--  商品属性-->
            <li>{{ $t("message.commodityAttribute") }}</li>
            <!--  附加服务-->
            <li>{{ $t("message.additionalServices") }}</li>
            <!--  商品数-->
            <li>{{ $t("message.numberOfGoods") }}</li>
            <!--  单价（元）-->
            <li class="flex05">{{ $t("message.priceYuan") }}</li>
            <!-- 问题图片-->
            <li class="flex12">{{ $t("message.problemPic") }}</li>
            <!-- 客户反馈问题诉求（日语）-->
            <li class="flex15">
              {{ $t("message.customerFeedbackProblemRequestJP") }}
            </li>
            <!--业务售后处理意见（日语）-->
            <li class="flex15">
              {{ $t("message.adviceOnAfterSaleHandlingOfBusinessJP") }}
            </li>
            <!-- 产生问题原因-->
            <li class="flex15">{{ $t("message.causeOfTheProblem") }}</li>
            <!-- 售后处理确认过程截图 -->
            <li class="flex12">
              {{ $t("message.screenshotOfAfterSalesProcessConfirmatio") }}
            </li>
            <!--赔款数量）-->
            <li>{{ $t("message.amountOfIndemnity") }}</li>
            <!--商品代赔款-->
            <li>{{ $t("message.indemnitiesForGoods") }}</li>
            <!--国内运费返还-->
            <li>{{ $t("message.returnOfDomesticFreight") }}</li>
            <!--手续费赔款-->
            <li>{{ $t("message.commissionIndemnity") }}</li>
            <!--option赔款-->
            <li>{{ $t("message.optionForCompensation") }}</li>
            <!--合计-->
            <li class="flex05">{{ $t("message.total") }}</li>
            <!--赔款承担-->
            <li>{{ $t("message.liabilityForLoss") }}</li>
          </ol>
          <!-- 列表详情 -->
          <div class="table_detail" v-for="(item, index) in detail.after_sale_detail" :key="index">
            <!-- 订单号分单-->
            <div class="detail_head">
              <div class="check">
                <el-checkbox v-model="item.checked" @change="orderCheck"></el-checkbox>
              </div>
              <!-- 订单 -->
              <div class="order">
                <div>
                  <p> <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank"
                      style="color: #fff;">{{ item.order_sn }}
                    </router-link></p>
                  <p>{{ item.user.realname }}</p>
                </div>
              </div>
              <!-- 订单汇率 -->
              <div class="item">
                {{ $t("message.orderRate") }}:{{ item.exchange_rate }}円/元
              </div>
              <div class="item">
                {{ $t("message.business") }}:{{ item.y_admin ? item.y_admin.realname : '' }}
              </div>
              <!-- 采购 -->
              <div class="item">
                {{ $t("message.purchase") }}: {{ item.g_admin ? item.g_admin.realname : '' }}
              </div>
              <!-- 配货 -->
              <div class="item">
                {{ $t("message.distribution") }}:{{ item.p_admin ? item.p_admin.realname : '' }}
              </div>
            </div>
            <!-- 列表 -->
            <ul v-for="(items, indexs) in item.list" :key="indexs">
              <!--  选择-->
              <li class="flex05">
                <el-checkbox v-model="items.checked" @change="singleOption"></el-checkbox>
              </li>
              <!--  番号-->
              <li class="flex05">{{ items.sorting }}</li>
              <!--  图片-->
              <li>
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" style="width: 60px; height: 60px" />
                  </a>
                </el-popover>
              </li>
              <!--  商品属性-->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--  附加服务-->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p v-if="opti.num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 80px">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                        <p v-if="opti.num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--  商品数-->
              <li>
                <div class="attribute">
                  <!-- 购买数 -->
                  <p>
                    {{ $t("message.purchaseNumber") }}:{{ items.confirm_num }}
                  </p>
                  <!-- 发送数 -->
                  <p>
                    {{ $t("message.numberOfTransmissions") }}:{{ items.fasong_num }}
                  </p>
                </div>
              </li>
              <!--  单价（元）-->
              <li class="flex05">{{ items.confirm_price }}</li>
              <!-- 问题图片-->
              <li class="flex12">
                <div class="imgList">
                  <div class="imgs" v-for="(imgs, imgIndex) in items.client_images" :key="imgIndex"
                    @click="getIndex(index, indexs, imgIndex)">
                    <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                      :show-file-list="false" :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <el-popover placement="right" trigger="hover">
                        <el-image :src="imgs" style="width: 300px;" :preview-src-list="[imgs]">
                        </el-image>
                        <el-image :src="imgs" slot="reference">
                          <div slot="error" class="image-slot">
                            <i class="el-icon-plus"></i>
                          </div>
                        </el-image>
                      </el-popover>
                    </el-upload>
                  </div>
                </div>
              </li>
              <!-- 客户反馈问题诉求（日语）-->
              <li class="flex15">
                <el-input type="textarea" v-model="items.client_desc"></el-input>
              </li>
              <!--业务售后处理意见（日语）-->
              <li class="flex15">
                <el-input type="textarea" v-model="items.admin_desc"></el-input>
              </li>
              <!-- 产生问题原因（内部） -->
              <li class="flex15">
                <el-input type="textarea" v-model="items.internal_reason"></el-input>
              </li>
              <!-- 售后处理确认过程截图 -->
              <li class="flex12">
                <div class="imgList">
                  <div class="imgs" v-for="(imgs, imgIndex) in items.admin_images" :key="imgIndex"
                    @click="getIndex(index, indexs, imgIndex)">
                    <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                      :show-file-list="false" :http-request="adminHandleAvatarSuccess"
                      :before-upload="beforeAvatarUpload">
                      <el-popover placement="right" trigger="hover">
                        <el-image :src="imgs" style="width: 300px;" :preview-src-list="[imgs]">
                        </el-image>
                        <el-image :src="imgs" slot="reference">
                          <div slot="error" class="image-slot">
                            <i class="el-icon-plus"></i>
                          </div>
                        </el-image>
                      </el-popover>
                    </el-upload>
                    <!-- 放大图片 -->
                  </div>
                </div>
              </li>
              <!--赔款数量）-->
              <li>
                <el-input type="number" v-model="items.num" onfocus="this.select()"></el-input>
              </li>
              <!--商品代赔款-->
              <li>
                <div class="attribute">
                  <!-- 编辑 -->
                  <el-button type="text" size="small"
                    @click="redact(index, indexs, 'amount_goods_amount', 'amount_goods_type', item)">
                    {{ $t("message.redact") }}
                  </el-button>
                  <p>{{ amountRefundName(items.amount_goods_type) }}</p>
                  <p>赔付：{{ items.amount_goods_amount }}</p>
                </div>
              </li>
              <!--国内运费返还-->
              <li>
                <div class="attribute">
                  <!-- 编辑 -->
                  <el-button type="text" size="small"
                    @click=" redact(index, indexs, 'amount_freight_amount', 'amount_freight_type', item)">
                    {{ $t("message.redact") }}
                  </el-button>
                  <p>{{ amountRefundName(items.amount_freight_type) }}</p>
                  <p>赔付：{{ items.amount_freight_amount }}</p>
                </div>
              </li>
              <!--手续费赔款-->
              <li>
                <div class="attribute">
                  <!-- 编辑 -->
                  <el-button type="text" size="small"
                    @click=" redact(index, indexs, 'amount_service_amount', 'amount_option_type', item)">
                    {{ $t("message.redact") }}
                  </el-button>
                  <p>{{ amountRefundName(items.amount_option_type) }}</p>
                  <p>赔付：{{ items.amount_service_amount }}</p>
                </div>
              </li>
              <!--option赔款-->
              <li>
                <div class="attribute">
                  <!-- 编辑 -->
                  <el-button type="text" size="small" @click="redactOption(index, indexs, items)">
                    {{ $t("message.redact") }}
                  </el-button>
                  <p v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex"></p>
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p v-if="opti.refund_num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.refund_num }} * {{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 80px">
                      <div class="row" v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex">
                        <p v-if="opti.refund_num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.refund_num }}*{{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--合计-->
              <li class="flex05">
                <div>
                  <p>{{ items.total }}.円</p>
                  <p>{{ (items.total / item.exchange_rate).toFixed(2) }}元</p>
                </div>
              </li>
              <!--预计承担金额-->
              <li>{{ $t("message.indemnityBearingRatio") }}</li>
            </ul>
          </div>
          <!-- 统计 -->
          <ol>
            <li style="flex: 12"></li>
            <!--合计-->
            <li>{{ $t("message.total") }}.円</li>
            <!--商品代赔款-->
            <li>{{ total.num }}</li>
            <!--商品代赔款-->
            <li>{{ total.amountGoods }}</li>
            <!--国内运费返还-->
            <li>{{ total.amountFreight }}</li>
            <!--手续费赔款-->
            <li>{{ total.amountService }}</li>
            <!--option赔款-->
            <li>{{ total.amountOption }}</li>
            <!--合计-->
            <li class="flex05">{{ total.allTotal }}</li>
            <li></li>
          </ol>
          <!-- option赔款 -->
          <indemnityOption ref="indemnityOption" :itemData="itemData" />
          <!-- 赔款选择 -->
          <refundModeEditing ref="refundModeEditing" :amountRefundType="amountRefundType" :itemData="itemData"
            :redactIndex="redactIndex" />
          <!-- 操作 -->
          <div class="operation">
            <!-- 添加内部赔款单 -->
            <el-button size="small" type="success" @click="addDlaimIndemnity">
              {{ $t("message.addAnInternalClaimSlip") }}
            </el-button>
            <span v-if="detail.status_name != '已完成'" style="margin-left: 20px;">
              <!-- 修改 -->
              <el-button size="small" type="primary" @click="porderGoodsUpdate" v-if="isAuth(347)">
                {{ $t("message.edit") }}
              </el-button>
              <!-- 删除 -->
              <el-button size="small" type="primary" class="dark" @click="afterSaleDelete" v-if="isAuth(349)">
                {{ $t("message.delete") }}
              </el-button>
              <!-- 确认 -->
              <el-button size="small" type="primary" @click="porderGoodsConfirm" v-if="isAuth(348)">
                {{ $t("message.confirm") }}
              </el-button>
              <!-- 完成 -->
              <el-button size="small" type="primary" @click="porderGoodsComplete" v-if="isAuth(344)">
                {{ $t("message.complete") }}
              </el-button>
            </span>
          </div>
        </div>
        <!-- 赔款单 -->
        <div v-else-if="adminList != false">
          <div v-for="(item, index) in detail.reparations" :key="index">
            <indemnityDetail :PKdetail="PKdetail" :amountRefundType="amountRefundType" :adminList="adminList"
              v-if="status == item.reparation_sn" />
          </div>
        </div>
      </div>
    </div>
    <!-- 商品售后 -->
    <claimIndemnity ref="claimIndemnity" :indemnityList="indemnityList" :amountRefundType="amountRefundType"
      :adminList="adminList" />
    <!-- 出入金预览 -->
    <previewOfDepositAndWithdrawal ref="previewOfDepositAndWithdrawal" :tableData="billPreviewList" showConfirm
      @confirm="submitPorderGoodsComplete" />
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import indemnityOption from "./components/indemnityOption";
import refundModeEditing from "./components/refundModeEditing";
import claimIndemnity from "./components/claimIndemnity";
import indemnityDetail from "./components/indemnityDetail";
import previewOfDepositAndWithdrawal from "../../problemDetail/components/previewOfDepositAndWithdrawal";
export default {
  components: {
    detailHeader,
    indemnityOption,
    refundModeEditing,
    claimIndemnity,
    indemnityDetail,
    previewOfDepositAndWithdrawal
  },
  data() {
    return {
      loading: false,
      after_sale_sn: this.$route.query.after_sale_sn,
      status: "1", //售后单详情
      detail: {},
      PKdetail: {},//赔款单详情
      index: {}, //图片索引
      redactIndex: {}, // 编辑索引
      itemData: {}, //计算赔款用
      amountRefundType: [],
      total: {
        amountGoods: 0,
        amountFreight: 0,
        amountService: 0,
        amountOption: 0,
        allTotal: 0,
      },
      option: [],
      checkList: [],
      indemnityList: [],//赔款列表
      adminList: [],//人员列表
      billPreviewList: [],//出入金预览

    };
  },
  computed: {},
  created() {
    this.$store.dispatch("getLogisticsList"); //物流方式获取
    this.$api.capitalApi.amountRefundType().then((res) => {
      this.amountRefundType = res.data;
    });
    // 获取赔款人
    this.$api.roleApi.accountNumberList({ pageSize: 99999, forSelect: 1 }).then(res => {
      this.adminList = res.data.data
    })
    this.aftersaleDetail();

  },
  methods: {

    // 详情
    aftersaleDetail() {
      let datas = {
        after_sale_sn: this.after_sale_sn,
      };
      this.$api.capitalApi.aftersaleDetail(datas).then((res) => {
        // 列表新增勾选
        res.data.after_sale_detail.forEach((item) => {
          item.checked = false;
          item.list.forEach((items) => {
            items.checked = false;
          });
        });

        // 赔款单新增列表
        res.data.reparations.forEach(item => {
          item.after_sale_detail = [] //创建一个列表
          res.data.after_sale_detail.forEach(order => {
            let orderItem = {}
            let list = []
            item.after_sale_id_contains.forEach(items => {
              let flag = order.list.some(orders => orders.id == items)
              // 找到有赔款商品的加头部
              if (flag) {
                orderItem = (JSON.parse(JSON.stringify(order)))
                orderItem.list = []
                order.list.forEach(orders => {
                  if (orders.id == items) {
                    list.push(orders)
                  }
                })
              }
            })
            orderItem.list = list
            item.after_sale_detail.push(orderItem)
          })
        })
        let reparation_sn = this.$route.query.reparation_sn
        this.detail = res.data;
        if (reparation_sn) {
          this.status = reparation_sn
          this.handleClick()
        }
        this.calculationTotal();

      });
    },
    // 切换状态
    handleClick() {
      this.PKdetail = this.detail.reparations.find(item => item.reparation_sn == this.status)

    },
    // 问题图片
    async handleAvatarSuccess(file) {
      let data = await this.createClient(file)
      this.detail.after_sale_detail[this.index.i].list[
        this.index.is
      ].client_images[this.index.iss] = data.data;
      this.loading = false
      this.$forceUpdate();
    },
    //售后处理确认过程截图
    async adminHandleAvatarSuccess(file) {
      let data = await this.createClient(file)
      this.detail.after_sale_detail[this.index.i].list[
        this.index.is
      ].admin_images[this.index.iss] = data.data;
      this.loading = false
      this.$forceUpdate();
    },
    // 获取图片索引
    getIndex(i, is, iss) {
      this.index = {
        i,
        is,
        iss,
      };

    },
    //编辑
    redact(index, indexs, amount, type, item) {
      this.redactIndex = {
        index,
        indexs,
        amount,
        type,
      };
      this.itemData = JSON.parse(JSON.stringify(item));
      this.$refs.refundModeEditing.dialogVisible = true;
    },
    // 编辑成功
    editSuccessfully(data) {
      this.detail.after_sale_detail[this.redactIndex.index].list[
        this.redactIndex.indexs
      ][this.redactIndex.amount] = data.amount;
      this.detail.after_sale_detail[this.redactIndex.index].list[
        this.redactIndex.indexs
      ][this.redactIndex.type] = data.type;

      this.calculationTotal();
      this.$forceUpdate();
    },
    // 上传前
    beforeAvatarUpload(file) {
      this.loading = true
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.loading = false
        return this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    //附加服务赔款 编辑
    redactOption(index, indexs, item) {
      this.redactIndex = {
        index,
        indexs,
      };
      this.itemData = JSON.parse(JSON.stringify(item));

      this.$refs.indemnityOption.dialogVisible = true;
    },
    // 附加服务赔款 编辑 成功
    redactOptionSuccess(data) {
      this.detail.after_sale_detail[this.redactIndex.index].list[
        this.redactIndex.indexs
      ].amount_option_detail = data;
      this.$forceUpdate();
      this.calculationTotal();
    },
    // 计算统计
    calculationTotal() {
      this.total = {
        amountGoods: 0,
        amountFreight: 0,
        amountService: 0,
        amountOption: 0,
        allTotal: 0,
        num: 0
      };
      this.detail.after_sale_detail.forEach((item) => {
        item.list.forEach((items) => {
          this.total.amountGoods += items.amount_goods_amount - 0;
          this.total.amountFreight += items.amount_freight_amount - 0;
          this.total.amountService += items.amount_service_amount - 0;
          items.amount_option_amount = 0;
          items.amount_option_detail.forEach((opti) => {
            let num = 0
            if (opti.price_type == 1) {
              if (opti.refund_num) {
                num = (
                  opti.refund_num *
                  items.confirm_price * (opti.price / 100) *
                  item.exchange_rate
                ).toFixed(0);
              }
            } else {
              if (opti.refund_num) {
                num = (
                  opti.refund_num *
                  opti.price *
                  item.exchange_rate
                ).toFixed(0);
              }

            }
            items.amount_option_amount += num - 0;
          });
          this.total.amountOption += items.amount_option_amount - 0;
          // 单条统计
          items.total =
            items.amount_option_amount -
            0 +
            (items.amount_goods_amount - 0) +
            (items.amount_freight_amount - 0) +
            (items.amount_service_amount - 0);
          //   合计统计
          this.total.allTotal += items.total;

          this.total.num += items.num - 0
        });
      });
    },
    //type转换name
    amountRefundName(key) {
      if (this.amountRefundType != false) {
        let item = this.amountRefundType.find((item) => item.key == key);
        return item.value;
      } else {
        return false;
      }
    },
    //售后-商品-修改
    porderGoodsUpdate() {
      let datas = {
        after_sale_sn: this.detail.after_sale_sn,
        porder_sn: this.detail.porder_sn,
        is_client_show: this.detail.is_client_show,
        list: [],
      };
      this.detail.after_sale_detail.forEach((item) => {
        item.list.forEach((items) => {
          datas.list.push({
            after_sale_detail_id: items.id,
            porder_detail_id: items.porder_detail_id,
            client_desc: items.client_desc,
            client_images: items.client_images,
            admin_desc: items.admin_desc,
            admin_images: items.admin_images,
            internal_reason: items.internal_reason,
            num: items.num,
            amountGoods: {
              type: items.amount_goods_type,
              amount: items.amount_goods_amount,
            },
            amountFreight: {
              type: items.amount_freight_type,
              amount: items.amount_freight_amount,
            },
            amountService: {
              type: items.amount_service_type,
              amount: items.amount_service_amount,
            },
            amountOption: {
              type: items.amount_option_type,
              amount: items.amount_option_amount,
              amount_option_detail: items.amount_option_detail ? items.amount_option_detail : [],
            },

          });

        });
      });
      this.$api.capitalApi.porderGoodsUpdate(datas).then((res) => {
        this.$message.success(res.msg);
        // this.aftersaleDetail();
      });
    },
    //删除售后单
    afterSaleDelete() {
      let datas = {
        after_sale_sn: this.after_sale_sn,
      };
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.capitalApi.afterSaleDelete(datas).then((res) => {
            this.$message.success(res.msg + "3秒后自动关闭页面");
            setTimeout(() => {
              window.open("about:blank", "_top").close();
            }, 3000);
          });
        })
        .catch(() => { });
    },
    //售后-商品-售后单确认
    porderGoodsConfirm() {
      let datas = {
        after_sale_sn: this.detail.after_sale_sn,
        porder_sn: this.detail.porder_sn,
        is_client_show: this.detail.is_client_show,
        list: [],
      };
      this.detail.after_sale_detail.forEach((item) => {
        item.list.forEach((items) => {
          datas.list.push({
            after_sale_detail_id: items.id,
            porder_detail_id: items.porder_detail_id,
            client_desc: items.client_desc,
            client_images: items.client_images,
            admin_desc: items.admin_desc,
            admin_images: items.admin_images,
            internal_reason: items.internal_reason,
            num: items.num,
            amountGoods: {
              type: items.amount_goods_type,
              amount: items.amount_goods_amount,
            },
            amountFreight: {
              type: items.amount_freight_type,
              amount: items.amount_freight_amount,
            },
            amountService: {
              type: items.amount_service_type,
              amount: items.amount_service_amount,
            },
            amountOption: {
              type: items.amount_option_type,
              amount: items.amount_option_amount,
              amount_option_detail: items.amount_option_detail ? items.amount_option_detail : [],
            },
          });
        });
      });
      this.$confirm(
        "是否售后单确认？",
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.$api.capitalApi.porderGoodsUpdate(datas).then(() => {
          this.$api.capitalApi.porderGoodsConfirm({ after_sale_sn: this.after_sale_sn }).then((res) => {
            this.$message.success(res.msg);
            this.aftersaleDetail();
          });
        });
      }).catch(() => { });
    },
    //售后单完成
    porderGoodsComplete() {
      this.$confirm(
        this.$t("message.afterSaleConfirmationMethod"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.completeDirectly"),
          cancelButtonText: this.$t("message.entryAndExitPreview"),
          distinguishCancelAndClose: true,
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.submitPorderGoodsComplete();
      }).catch((action) => {
        if (action == 'cancel') this.submitPorderGoodsComplete(true);
      });
    },
    // 售后完成；预览时才传 preview_bill，预览弹框确认时不传。
    submitPorderGoodsComplete(preview = false) {
      const datas = { after_sale_sn: this.after_sale_sn };
      if (preview) datas.preview_bill = 1;
      this.$api.capitalApi.porderGoodsComplete(datas).then((res) => {
        if (preview) {
          this.billPreviewList = res.data;
          this.billPreviewList.forEach(item => {
            item.adjust_detail = JSON.parse(item.adjust_detail);
          });
          this.$refs.previewOfDepositAndWithdrawal.dialogVisible = true;
          return;
        }
        this.$refs.previewOfDepositAndWithdrawal.dialogVisible = false;
        this.$message.success(res.msg);
        this.aftersaleDetail();
      });
    },
    //订单选择
    orderCheck() {
      this.checkList = [];
      this.detail.after_sale_detail.forEach((item) => {
        item.list.forEach((items) => {
          items.checked = item.checked;
        });
        if (item.checked) {
          this.checkList = [...this.checkList, ...item.list];
        }
      });
    },
    //单选
    singleOption() {
      this.checkList = [];
      this.detail.after_sale_detail.forEach((item) => {
        item.checked = item.list.every((items) => items.checked);
        item.list.forEach((items) => {
          this.checkList.push(items);
        });
      });
    },
    //添加内部赔款单
    addDlaimIndemnity() {
      this.indemnityList = []
      this.detail.after_sale_detail.forEach(item => {
        let flag = item.list.some(item => item.checked)
        if (flag) {
          let orderItem = JSON.parse(JSON.stringify(item))
          orderItem.list = orderItem.list.filter(items => items.checked)
          orderItem.list.forEach(items => {
            items.checked = false
            items.rate = 100
          })
          this.indemnityList.push(orderItem)
        }
      })
      if (this.indemnityList == false) return this.$message.error(this.$t('message.selectableOperationalList'))
      this.$refs.claimIndemnity.dialogVisible = true

    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.detail {
  min-width: 1910px;

  .baseBreadcrumb {
    margin: 24px;
  }

  .content {
    padding: 24px;
    margin: 24px;
    background: #f8f8f8;
    border-radius: 8px;

    .head {
      padding: 15px 24px;
      background-color: #ececec;
      border-radius: 8px;
      display: flex;
      position: relative;
      margin-bottom: 32px;

      .item {
        margin-right: 78px;
      }

      .el-button {
        position: absolute;
        top: 15px;
        right: 24px;
      }
    }

    .table {
      .table_detail {
        .detail_head {
          display: flex;
          font-size: 14px;
          height: 60px;
          background: #545467;
          border-radius: 4px;
          color: #fff;
          margin-top: 20px;

          .check {
            width: 53px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .order {
            display: flex;
            align-items: center;
            padding-left: 16px;
          }

          .item {
            margin-left: 60px;
            line-height: 60px;
          }
        }
      }

      font-size: 12px;

      ol {
        display: flex;
        text-align: center;
      }

      ul {
        display: flex;
        padding: 0;
        border: 0;

        li {
          padding: 24px 5px;
          position: relative;
        }
      }

      li {
        padding: 0 5px;
      }

      .flex12 {
        flex: 1.2;
      }

      .flex15 {
        flex: 1.5;
      }

      .flex05 {
        flex: 0.5;
      }

      .attribute {
        width: 100%;
        text-align: left;
        max-height: 100px;
        overflow: hidden;

        .el-button {
          position: absolute;
          top: 5px;
          right: 10px;
        }
      }

      .imgList {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .imgs {
          width: 40px;
          height: 40px;
          margin: 0px 0px 10px 10px;

          .el-image {
            width: 40px;
            height: 40px;
            border: 1px dashed #ccc;
            text-align: center;
            line-height: 40px;
            font-size: 20px;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }

      .operation {
        position: sticky;
        left: 0;
        bottom: 0;
        text-align: right;
        padding: 15px 24px;
        background-color: #edeff4;
        margin-top: 20px;
        border-radius: 0px 0px 8px 8px;
        z-index: 99;
      }
    }
  }

  margin-bottom: 20px;
}

/deep/.el-upload-dragger {
  width: 40px;
  height: 40px;
}
</style>
